import React from 'react'; 
import ReactScrollLink from '../../General/ReactScollLink';
import Translation from '../../General/Translation';

const DetailsButton = ({movieId, movieTitle, scrollToPosition, translation, itemDetailsOpen, closeItemDetails, openItemDetails, additionalClass=""}) => {
    if(itemDetailsOpen === true) {
        return (
            <div className="button-details-wrapper">
                <ReactScrollLink to={scrollToPosition  + ' movieInformation'} smooth={false} offset={-200} className={'toggle-details'}>
                    <button onClick={() => closeItemDetails({movieId: movieId, movieTitle: movieTitle})} className={"button details text-light cursor-pointer" + additionalClass}><Translation id="close" trans={translation}>Schließen</Translation></button>
                </ReactScrollLink>
            </div>
        )
    } else {
        return (
            <div className="button-details-wrapper">
                <ReactScrollLink to={scrollToPosition + ' movieDetails'} smooth={true} offset={-100} className={'toggle-details'}>
                    <button onClick = {() => openItemDetails({movieId: movieId, movieTitle: movieTitle})} className={"button details text-light cursor-pointer" + additionalClass}><Translation id="details" trans={translation}>Details</Translation></button>
                </ReactScrollLink>
            </div>
        )
    }
}

export default DetailsButton